import {RouteRecordRaw} from "vue-router";
import BirthdayGiftsScreen from "@/birthday-gift/views/BirthdayGiftsScreen.vue";
import BirthdayTodayScreen from "@/birthday-gift/views/BirthdayTodayScreen.vue";
import BirthdayGiftStatisticsScreen from "@/birthday-gift/views/BirthdayGiftStatisticsScreen.vue";

/**
 * Routes of the « Cadeaux d'anniversaire » module, mounted as children
 * of the patient-administration route (communication section).
 */
const routes: RouteRecordRaw[] = [
    {
        path: 'communication/birthday-gifts',
        name: 'patient-administration.communication.birthday-gifts',
        component: BirthdayGiftsScreen
    },
    {
        path: 'communication/birthday-gifts/today',
        name: 'patient-administration.communication.birthday-gifts.today',
        component: BirthdayTodayScreen
    },
    {
        path: 'communication/birthday-gifts/:giftId/statistics',
        name: 'patient-administration.communication.birthday-gifts.statistics',
        component: BirthdayGiftStatisticsScreen,
        props: true
    }
];

export default routes;
